<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="showPopup"
    append-to-body
    class="request-form-dialog"
    custom-class="request-form-modal product-request-modal">
    <div slot="title" class="request-modal-titlebar">
      <h2>{{dialogTitle}}</h2>
    </div>

    <el-form
      :label-position="'top'"
      :inline="false"
      :rules="rules"
      label-width="100%"
      :model="selectedObject"
      ref="my-form"
      class="request-form"
      @submit.prevent="save"
      v-loading="loading">
      <div class="request-product-layout">
        <section class="request-panel request-details-panel">
          <div class="request-panel-heading">{{$t('products.basic_information')}}</div>

          <div class="request-field-grid two-columns">
            <el-form-item :label="$t('products.name')" prop="Name" :required="true">
              <el-input v-model="selectedObject.Name" autofocus></el-input>
            </el-form-item>

            <el-form-item :label="$t('products.article_number')" prop="ArticleNumber" :required="true">
              <el-input v-model="selectedObject.ArticleNumber"></el-input>
            </el-form-item>
          </div>

          <el-form-item :label="$t('products.category')" prop="IdCategory" :required="true">
            <el-select v-model="selectedObject.IdCategory" filterable class="full-width">
              <el-option v-for="item in categories" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('products.marketplace_price')" prop="MarketplacePrice">
            <el-input
              v-model="selectedObject.MarketplacePrice"
              type="number"
              step="0.05"
              min="0"
              class="full-width">
            </el-input>
            <div class="field-hint">{{$t('products.marketplace_price_hint')}}</div>
          </el-form-item>

          <el-form-item :label="$t('products.description')" prop="Description" :required="true">
            <el-input type="textarea" :rows="5" v-model="selectedObject.Description"></el-input>
          </el-form-item>
        </section>

        <section class="request-panel request-media-panel">
          <div class="request-panel-heading">{{$t('products.product_image')}}</div>

          <el-form-item :label="$t('products.image')" prop="Image" :required="true">
            <el-upload
              ref="productUpload"
              class="request-image-upload"
              drag
              :headers="getHeaders()"
              :multiple="false"
              :limit="1"
              :show-file-list="false"
              :action="getUploadUrl()"
              :on-success="handleImageUploadSuccess">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">{{$t('products.upload_image')}}</div>
              <div slot="tip" class="el-upload__tip">{{$t('products.upload_hint')}}</div>
            </el-upload>
          </el-form-item>

          <div class="request-preview-label">{{$t('products.preview')}}</div>
          <div :class="['request-image-preview', { 'is-empty': !hasPreviewImage }]">
            <el-image
              v-if="hasPreviewImage"
              :src="imageUrl"
              fit="cover">
            </el-image>
            <div v-else class="request-empty-preview">
              <i class="el-icon-picture-outline"></i>
              <span>{{$t('products.no_image_selected')}}</span>
            </div>
          </div>
        </section>
      </div>
    </el-form>

    <span slot="footer" class="request-modal-footer">
      <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" :loading="loading" @click="save">{{ submitLabel }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable prettier/prettier */
import settings from "./../../backend/LocalSettings";
import LocalSettings from './../../backend/LocalSettings';

export default {
  name: "product-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
      selectedObject: {},
      categories: [],
      request_new_mode: 0,
      imageUrl: "",
      rules: {
          Name: [ { required: true, message: this.$t('products.required_name') } ],
          ArticleNumber: [ { required: true, message: this.$t('products.required_article_number')  } ],
          Description: [ { required: true, message: this.$t('products.required_description') } ],
          IdCategory: [ { required: true, message: this.$t('products.required_category')  } ],
      }
    }
  },
  computed: {
    dialogTitle: function() {
      return this.request_new_mode ? this.$t("products.request_dialog_title") : this.$t("products.dialog_title");
    },
    submitLabel: function() {
      return this.request_new_mode ? this.$t("products.submit_request") : this.$t("confirm");
    },
    hasPreviewImage: function() {
      return !!(this.selectedObject && this.selectedObject.Image && this.selectedObject.Image !== "default.jpg" && this.imageUrl);
    }
  },
  methods: {
      getUploadUrl(){
        return LocalSettings.base_url + "/api/index.php/products/upload_image";
      },
      getHeaders(){
        var token =LocalSettings.get_token();
        var ret = { Token: token };
        return ret;
      },
     show_me: function( selectedObject, request_new_mode = 0 ) {
        this.mode = "edit";
        if( selectedObject == null ) {
            selectedObject = { MarketplacePrice: null, Image: "" };
            this.mode = "add";
        }
        if( this.mode == "edit" ){
          this.imageUrl = LocalSettings.base_url + "/api/assets/products/" + selectedObject.Image;
        } else {
          this.imageUrl = "";
        }
        this.request_new_mode = request_new_mode;
        this.showPopup        = true;
        this.selectedObject   = JSON.parse( JSON.stringify( selectedObject ) );
    },
    handleImageUploadSuccess(res){
      this.imageUrl = res.Url;
      this.selectedObject.Image = res.FileName;
      if(this.$refs.productUpload) {
        this.$refs.productUpload.clearFiles();
      }
    },
    load_info: function(){
        this.loading = true;
        this.$http
          .post('products/get_info',  {  } )
          .then(function (response) {
            this.loading = false;
            if( settings.verify_response(response, this.$rights)) {
              this.categories = response.body.Categories;
            } else {
              this.$router.push("/");
            }
          });
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('products/save',  { mode: this.mode, object: this.selectedObject, request_new_mode: this.request_new_mode } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                this.showPopup = false;
                this.$emit("save");
                } else {
                this.$router.push("/");
                }
            });
          }
        });
    }
  },
  mounted: function() {
      this.load_info();
  }
};
</script>

<style lang="less">
@import "../../styles/request-dialog.less";
</style>
